import React from 'react';
import { Typography } from '@mui/material';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import { useTranslation } from 'react-i18next';
import CommonButton from '@src/new-components/Button';
import ReferralImg from '@src/assets/images/referral-reward-vi.svg';
import ReferralImgEn from '@src/assets/images/referral-reward-en.svg';
import { COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/constants';
import useWindowDimensions from '@src/hooks/useWindowDimensions';
import { StyledReferralIntroSection } from './index.style';

const RESOURCE_HUB_URL =
  'https://drive.google.com/drive/folders/1PePWk-WmuaiSDx6PplO0-xqHEFHhMpjs';

const ReferralIntro = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const isVietnamese = language === 'vi';
  const { width } = useWindowDimensions();
  const isMobile = width <= MOBILE_BREAKPOINT;

  const renderResourceHubButton = () => (
    <CommonButton
      variant="outlined"
      startIcon={
        <ImportContactsIcon
          sx={{
            width: isMobile ? 16 : 24,
            height: isMobile ? 16 : 24,
            color: COLOR.darkBlue,
          }}
        />
      }
      onClick={() => {
        window.open(RESOURCE_HUB_URL, '_blank');
      }}
      customStyle={{
        padding: isMobile ? '8px' : '8px 16px',
        borderRadius: '8px',
        height: isMobile ? '32px' : '40px',
        minWidth: isMobile ? '116px' : '160px',
        border: `${isMobile ? 0.5 : 1}px solid ${COLOR.indigo[16]}`,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        '& .MuiButton-startIcon': {
          marginLeft: 0,
        },
      }}
      textProps={{
        variantText: isMobile ? 'body-12-medium' : 'body-14-semibold',
        color: COLOR.darkBlue,
      }}
    >
      {t('referralResourceHub')}
    </CommonButton>
  );

  return (
    <StyledReferralIntroSection>
      <div className="intro-image">
        <img
          src={isVietnamese ? ReferralImg : ReferralImgEn}
          className="referral-img"
          alt="referral"
        />
      </div>
      <div className="intro-content">
        <div className="intro-title-container">
          <Typography className="intro-title">
            {t('newReferralIntroTitle')}
          </Typography>
          <Typography className="intro-description">
            {t('newReferralIntroDescription')}
          </Typography>
        </div>
        {renderResourceHubButton()}
      </div>
    </StyledReferralIntroSection>
  );
};

export default ReferralIntro;
